const BaseApi = 'https://sandbox.merchant.vn/v1/'

export default BaseApi